import React, { FunctionComponent } from 'react';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  RedditShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  RedditIcon,
  EmailIcon
} from 'react-share';

import style from './ShareBar.module.less';

interface ShareBarProps {
  shareUrl: string;
  title: string;
}

export const ShareBar: FunctionComponent<ShareBarProps> = ({ shareUrl, title }) => (
  <div className={style.shareBar}>
    <div className={style.shareButtonWrapper}>
      <FacebookShareButton
        url={shareUrl}
        quote={title}
        className={style.shareButton}
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>
    </div>

    <div className={style.shareButtonWrapper}>
      <TwitterShareButton
        url={shareUrl}
        title={title}
        className={style.shareButton}
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>
    </div>

    <div className={style.shareButtonWrapper}>
      <LinkedinShareButton url={shareUrl} className={style.shareButton}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
    </div>

    <div className={style.shareButtonWrapper}>
      <RedditShareButton
        url={shareUrl}
        title={title}
        windowWidth={660}
        windowHeight={460}
        className={style.shareButton}
      >
        <RedditIcon size={32} round />
      </RedditShareButton>
    </div>

    <div className={style.shareButtonWrapper}>
      <EmailShareButton
        url={shareUrl}
        subject={title}
        body="body"
        className={style.shareButton}
      >
        <EmailIcon size={32} round />
      </EmailShareButton>
    </div>
  </div>
);
